import { App as AntdApp, ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import { AuthProvider } from '@/auth/AuthContext';
import { StepUpModal } from '@/components/StepUpModal';
import { router } from '@/router';
import { themeConfig } from '@/theme';
import { RouterProvider } from 'react-router-dom';

dayjs.locale('zh-cn');

export default function App() {
  return (
    <ConfigProvider locale={zhCN} theme={themeConfig}>
      <AntdApp>
        <AuthProvider>
          <RouterProvider router={router} />
        </AuthProvider>
        <StepUpModal />
      </AntdApp>
    </ConfigProvider>
  );
}
